import { ErrorContract } from '@/core/generated/api';
import { toast } from 'sonner';

const forbiddenToastId = 'api-forbidden';
const defaultForbiddenMessage = 'Недостаточно прав для выполнения операции';

/** Проверяет, является ли ответ объектом */
const isRecord = (value: unknown): value is Record<string, unknown> => (
    typeof value === 'object' && value !== null
);

/** Показывает единое уведомление об отказе в доступе. */
export const handleForbiddenApiError = (error: unknown): string => {
    const response = isRecord(error) && isRecord(error.response)
        ? error.response
        : null;

    const errorData = response?.data as ErrorContract | undefined;
    const message = errorData?.message || defaultForbiddenMessage;

    toast.error(message, { id: forbiddenToastId });

    return message;
};
